import { useId } from 'react';
import type { Question } from '../../data/schemas';
import type { ClusterResult } from '../../types/result';
import { Dialog } from '../ui/Dialog';
import { ClusterDetailContent } from './ClusterDetailContent';

interface ClusterDetailModalProps {
  cluster: ClusterResult | null;
  questions: readonly Question[];
  showWeightingDetails: boolean;
  onClose: () => void;
}

/** Alternative Darstellung der Cluster-Detailanalyse als Dialog statt Anker-Sprung (settings.yaml: resultPage.clusterDetailMode). */
export function ClusterDetailModal({
  cluster,
  questions,
  showWeightingDetails,
  onClose,
}: ClusterDetailModalProps) {
  const titleId = useId();

  return (
    <Dialog
      open={cluster !== null}
      onClose={onClose}
      titleId={titleId}
      title={cluster?.title ?? ''}
    >
      {cluster && (
        <div className="stack">
          <ClusterDetailContent
            cluster={cluster}
            questions={questions}
            showWeightingDetails={showWeightingDetails}
            showTitle={false}
          />
        </div>
      )}
    </Dialog>
  );
}
